// types
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MenuProps } from 'types/menu';
import { readSidebarExpanded } from 'utils/sidebarExpanded';

/** From the `xl` breakpoint (`--breakpoint-xl` in `src/index.css`) up the drawer opens expanded, below it collapsed. */
export const DRAWER_OPEN_QUERY = '(min-width: 1536px)';

// initial state
const initialState: MenuProps = {
    openItem: ['dashboard'],
    openComponent: 'buttons',
    // Read when the store is built, so the drawer's first frame already has its width.
    drawerOpen: readSidebarExpanded() ?? window.matchMedia(DRAWER_OPEN_QUERY).matches,
    componentDrawerOpen: true,
    focusedEditMode: false,
    fullscreenMode: true,
};

// ==============================|| SLICE - MENU ||============================== //

const menu = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        activeItem(state, action) {
            state.openItem = action.payload.openItem;
        },

        openDrawer(state, action) {
            state.drawerOpen = action.payload.drawerOpen;
        },

        setFocusedEditMode(state, action) {
            state.focusedEditMode = action.payload;
        },

        toggleFullscreenMode(state) {
            state.fullscreenMode = !state.fullscreenMode;
        },

        setFullscreenMode(state, action) {
            state.fullscreenMode = action.payload;
        },

        declineFocusedEdit(state, action: PayloadAction<string>) {
            state.focusedEditDeclinedFor = action.payload;
        },

        withdrawFocusedEditDecline(state) {
            state.focusedEditDeclinedFor = undefined;
        },
    },
});

export default menu.reducer;

export const {
    activeItem,
    openDrawer,
    setFocusedEditMode,
    toggleFullscreenMode,
    setFullscreenMode,
    declineFocusedEdit,
    withdrawFocusedEditDecline,
} = menu.actions;
